import React from 'react';
import { Route, IndexRedirect, IndexRoute } from 'react-router';
import TabBar from '../TabBar';

import DataSourceList from './DataSourceList';
import DataSourceModify from './DataSourceModify';
import DataSourceOriginList from './DataSourceOriginList';
import DataSourceOriginAdd from './DataSourceOriginAdd';
import DataSourceOriginEdit from './DataSourceOriginEdit';
import DataSourceOriginParameterAdd from './DataSourceOriginParameterAdd';
import DataSourceOriginParameterEdit from './DataSourceOriginParameterEdit';
import DaqProcessorList from './DaqProcessorList';
import DaqProcessorAdd from './DaqProcessorAdd';
import DaqProcessorEdit from './DaqProcessorEdit';
import DataOriginParameterList from "./DataOriginParameterList";
import DaqManualImport from './DaqManualImport';
import RequestList from '../Request/RequestList';
import RequestDetail from '../Request/RequestDetail';
import RequestDetailRequestErrorList from '../Request/RequestDetailRequestErrorList';
import RequestDetailRawDataList from '../Request/RequestDetailRawDataList';
import RequestDetailOriginDataList from '../Request/RequestDetailOriginDataList';
import RequestDetailObservationList from '../Request/RequestDetailObservationList';
import DataOriginParameterTemplateView from "./DataOriginParameterTemplateView";
import DAQRawData from '../DAQRawData';
import { checkRolePermission } from '../../libs/checkPermission';
import DataSourceOriginModify from './DataSourceOriginModify';
import DataSourceOriginParameterModify from './DataSourceOriginParametermodify';
// import DaqLocationList from "./DaqLocationList";
// import DaqLocationAdd from "./DaqLocationAdd";
// import DaqLocationEdit from "./DaqLocationEdit";

const Home = props => {
  return (
    <div className='inner-section-root'>
      <TabBar
        items={[
          { to: '/daq/data-source', label: 'Data Source' },
          { to: '/daq/daq-processor', label: 'Daq Processor' },
          // { to: '/daq/location', label: 'Daq Location' },
          { to: '/daq/request', label: 'Request' },
          { to: '/daq/raw_data', label: 'Raw Data' },
          { to: '/daq/parameter-template', label: 'Origin Parameter Template' },
          { to: '/daq/manual-import', label: 'Manual Import' },
        ]}
      />
      <div className='inner-section-content'>
        {props.children}
      </div>
    </div>
  );
};

export const DAQRoutes = () => (
  <Route component={Home}>
    <IndexRedirect to="data-source" />
    {/*<Route path="request" component={checkRolePermission(DAQ)} name="view daq" />*/}
    <Route path="request">
      <IndexRoute component={RequestList} />
      <Route path=":id" component={RequestDetail}>
        <Route path="request-error" component={RequestDetailRequestErrorList} />
        <Route path="raw-data" component={RequestDetailRawDataList} />
        <Route path="origin-data" component={RequestDetailOriginDataList} />
        <Route path="observation" component={RequestDetailObservationList} />
      </Route>
    </Route>
    <Route path="raw_data" component={DAQRawData} />
    <Route path="data-source" component={checkRolePermission(DataSourceList)} name='view data-source'>
      <Route path=":id" component={checkRolePermission(DataSourceModify)} name='modify data-source' />
      <Route path=":id">
        <Route path="data-origin"
          components={{
            main: DataSourceOriginList,
            // sidebar: DaqProcessorList,
          }}
        >
          {/* <Route path="add" component={checkRolePermission(DataSourceOriginAdd)} name='modify data-origin' /> */}
          <Route path=":dataOriginId" component={checkRolePermission(DataSourceOriginModify)} name='modify data-origin' />
          <Route path=":dataOriginId/data-origin-parameter">
            {/* <Route path="add" component={DataSourceOriginParameterAdd} /> */}
            <Route path=":dataOriginParameterId" component={DataSourceOriginParameterModify} />
          </Route>
        </Route>
      </Route>
    </Route>
    <Route path="daq-processor" component={DaqProcessorList}>
      <Route path="add" component={DaqProcessorAdd} />
      <Route path=":daqProcessorId" component={DaqProcessorEdit} />
    </Route>
    <Route path='parameter-template' component={DataOriginParameterList}>
      <Route path=':id' component={DataOriginParameterTemplateView} />
    </Route>
    <Route path='manual-import' component={DaqManualImport} />
    {/*<Route path='location' component={DaqLocationList}>*/}
    {/*<Route path="add" component={DaqLocationAdd} />*/}
    {/*<Route path=":id" component={DaqLocationEdit}/>*/}
    {/*</Route>*/}
  </Route>

);


// WEBPACK FOOTER //
// ./src/components/DataSource/routes.js